module.exports = __webpack_public_path__ + "a7ebf15f490d62f645409790dc915592.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Mission/images/quotation.svg
// module id = 1268
// module chunks = 7